import { cva, type VariantProps } from "class-variance-authority";
import type { HTMLAttributes } from "react";

import { cn } from "./cn";

/** Status chips. Tones differ in lightness as well as hue, so they read without colour vision too. */
export const badgeVariants = cva(
  "inline-flex h-[26px] items-center gap-1.5 rounded-full px-2.5 text-xs font-bold whitespace-nowrap",
  {
    variants: {
      tone: {
        neutral: "bg-neutral-soft text-neutral",
        success: "bg-primary-soft text-primary-soft-ink",
        info: "bg-info-soft text-info",
        warn: "bg-warn-soft text-warn",
        danger: "bg-danger-soft text-danger",
      },
    },
    defaultVariants: { tone: "neutral" },
  },
);

export type BadgeTone = NonNullable<VariantProps<typeof badgeVariants>["tone"]>;

export function Badge({
  tone,
  className,
  ...props
}: HTMLAttributes<HTMLSpanElement> & VariantProps<typeof badgeVariants>) {
  return <span className={cn(badgeVariants({ tone }), className)} {...props} />;
}
